module.exports = __webpack_public_path__ + "static/media/christy-schmidt.2008d289.jpg";